import type { Object3D } from 'three/webgpu';
import {
  isComponentInstanceTransformProxyObject,
  resolveComponentInstanceTransformTarget,
  type ComponentInstanceTransformTargetResolverHost,
} from '../component-instance';

/**
 * Move/Rotate 组件 transform 目标解析宿主。
 *
 * 设计说明：
 * 该类型保留 Move/Rotate 模块的既有导出名称，实际协议由 component-instance 公共模块维护，
 * 保证 Mate、Move 和 Rotate 对“可写组件根”的定义完全一致。
 */
export type MoveComponentTransformTargetResolverHost = ComponentInstanceTransformTargetResolverHost;

/**
 * 判断对象是否为不能承载组件 transform 的拓扑代理或导入模型叶子对象。
 *
 * @param object 待判断对象。
 * @returns 是否应被 Move/Rotate 根解析拒绝。
 */
export function isMoveComponentTransformProxyObject(object: Object3D | null | undefined): boolean {
  return isComponentInstanceTransformProxyObject(object);
}

/**
 * 解析 Move/Rotate 命令真正应写入 transform 的组件对象。
 *
 * @param object 当前选中或命中的场景对象。
 * @param host 解析宿主。
 * @returns 可写组件根；无有效目标时返回 null。
 */
export function resolveMoveComponentTransformTarget(
  object: Object3D | null | undefined,
  host: MoveComponentTransformTargetResolverHost,
): Object3D | null {
  return resolveComponentInstanceTransformTarget(object, host);
}
